import { MagicWandIcon } from "@radix-ui/react-icons";
import { ExclamationIcon } from "@heroicons/react/outline";

import { getNodeTypeConfig, getSpanDisplayType } from "./utils";

import { BlockIcon, BlockType } from "@/components/PowerBlock/Blocks";
import { getEntityColor } from "@/components/UnifiedRegistry/utils";
import EntityIcon from "@/components/ui/icons/EntityIcon";
import { SpanNode } from "@/types/spans";
import { cn } from "@/lib/utils";
import { EntityType } from "@/queries/folder-entities/types";

export const SpanIcon = ({
  spanNode,
  isPromptLayerTool = false,
  className,
}: {
  spanNode: SpanNode;
  isPromptLayerTool?: boolean;
  className?: string;
}) => {
  const iconClass = "h-3.5 w-3.5 text-white";
  const wrapperClassName = cn(
    "my-auto ml-2 inline-flex h-5 w-5 items-center justify-center rounded-full p-1",
    className,
  );

  const hasError =
    spanNode.status?.status_code === "StatusCode.ERROR" ||
    spanNode.events?.some(event => event.name === "exception");

  if (hasError) {
    return (
      <div className={cn(wrapperClassName, "bg-red-50")}>
        <ExclamationIcon className={cn(iconClass, "text-red-600")} />
      </div>
    );
  }

  const nodeType = getSpanDisplayType(spanNode);

  if (isPromptLayerTool) {
    return (
      <div className={cn(wrapperClassName, getEntityColor(EntityType.TOOL))}>
        <EntityIcon type={EntityType.TOOL} size="xs" className="h-3.5 w-3.5" />
      </div>
    );
  }

  if (nodeType) {
    const config = getNodeTypeConfig(nodeType, iconClass);
    return <div className={cn(wrapperClassName, config.bgColor)}>{config.icon}</div>;
  }

  if (spanNode.request_log_id) {
    return (
      <div className={cn(wrapperClassName, "bg-purple-50")}>
        <MagicWandIcon className={cn(iconClass, "text-purple-600")} />
      </div>
    );
  }

  const DefaultIcon = BlockIcon[BlockType.CODE_EXECUTION];
  return (
    <div className={cn(wrapperClassName, "bg-blue-50")}>
      {DefaultIcon ? <DefaultIcon className={cn(iconClass, "text-blue-600")} /> : null}
    </div>
  );
};
